function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#000",
  strokeWidth: 2.358,
  d: "M53.677 19L18.525 54.152M18.525 17.855l35.153 35.153"
});

function SvgCalculatorIcon3(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 71 72",
    fill: "none"
  }, props), _ref);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNzEiIGhlaWdodD0iNzIiIHZpZXdCb3g9IjAgMCA3MSA3MiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGxpbmUgeDE9IjUzLjY3NzMiIHkxPSIxOC45OTk1IiB4Mj0iMTguNTI0OSIgeTI9IjU0LjE1MiIgc3Ryb2tlPSJibGFjayIgc3Ryb2tlLXdpZHRoPSIyLjM1NzU3Ii8+CjxsaW5lIHgxPSIxOC41MjU0IiB5MT0iMTcuODU1NCIgeDI9IjUzLjY3NzgiIHkyPSI1My4wMDc5IiBzdHJva2U9ImJsYWNrIiBzdHJva2Utd2lkdGg9IjIuMzU3NTciLz4KPC9zdmc+Cg==";
export { SvgCalculatorIcon3 as ReactComponent };